import ImmunizationTBView from "./ImmunizationTBView";

export default ImmunizationTBView;
